export enum AlertType {
  Error = "error",
  Information = "info",
  Success = "success",
}
